import { z } from 'zod'

export const languageSchema = z.enum(['en', 'hi'])
export type Language = z.infer<typeof languageSchema>

export const contentTypeSchema = z.enum([
  'article',
  'quote',
  'youtube',
  'short',
  'ebook',
  'video',
  'pdf',
])
export type ContentType = z.infer<typeof contentTypeSchema>

export type PaginatedResponse<T> = {
  items: T[]
  page: number
  pageSize: number
  total: number
}
